import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
    BrowserRouter,
    Routes,
    Route,
} from 'react-router-dom';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Home from './pages/Home';
import Register from './pages/Register';
import Success from './pages/Success';
import Contact from './pages/Contact';
import Scheduled from './pages/Scheduled';

if (localStorage.getItem("language") == null)
    localStorage.setItem("language", 'es_ES');

i18n
    .use(initReactI18next)
    .init({
        resources: {
            es_ES: require('./lang/es_ES.json'),
            en_EN: require('./lang/en_EN.json')
        },
        lng: localStorage.getItem("language") || 'es_ES',
        fallbackLng: localStorage.getItem("language") || 'en_EN',

        interpolation: {
            escapeValue: false
        }
    });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/success" element={<Success />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/scheduled" element={<Scheduled />} />
        </Routes>
    </BrowserRouter>
);